// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"ad80ccb8","176":"ba87b29b","466":"6fad370d"}[chunkId] + ".css";
};